define('commons/simulation-coverage-map',['jquery', 'commons/tap-coverage-map', 'commons/launch-coverage-button', 'commons/context-menu', 'commons/message-manager', 'utils/periodic-checker', 'utils/icons', 'utils/application-data', 'commons/city-area-info', 'MeasureTool', 'async!google-maps'], function($, BaseStationCoverageMap, LaunchCoverageButton, ContextMenu, messages, periodicChecker, icon, appData, CityArea, MeasureTool) {
    var SimulationCoverageMap = function(simulationId, mapNodeId, options) {
        
        var opts = {
            onDevicesAdded : function(){},
            canEditSimulation: false,
            readOnlyMode:false,
            running: false,
            updated: false,
            hasHiddenUpdated: false,
            hasDeleted: false,
            deviceMode: "STATUS",
            launchButtonSelector: "",
            hasEmptyCoverage: true,
            ajaxUrl: "",
            afterLoadCoverage: function(data) {},
            onRemoveSpot: function(markerInfo) {},
            onResetCoverage: function(markerInfo,data){},
            onSuccessProcess: function(status) {},
            spotTypeSelector : null,
            bigLaunchSpots: 50,
            bigLaunchTime: 300000,
            useTile: false,
            cityArea : {
                display: false,
                isDisabled : true,
                list : null,
                opacity: 15
            },
            displayMarkers: true,
            refreshGeodata: false
        };
        $.extend(opts, options);

        // Call parent init method
        BaseStationCoverageMap.call(this, mapNodeId, opts);

        this.simulationId = simulationId;
        this.staticUrl = "/spot/" + simulationId + "/static";
        this.spotUrl = "/spot/" + simulationId + "/coveragespot";
        
        // diplayable city area
        if (this.settings.cityArea.display) {
            this.makeToggleCityArea();
            this.cityArea = new CityArea(null, this.map);
        }

        this.launchCoverageButton = new LaunchCoverageButton(this.settings.launchButtonSelector, "#" + mapNodeId, '.simu-toolbar', {
            running : this.settings.running,
            updated : this.settings.updated,
            hasDeleted : this.settings.hasDeleted,
            hasHiddenUpdated : this.settings.hasHiddenUpdated,
            hasEmptyCoverage : this.settings.hasEmptyCoverage
        });
        
        this.launchCoverageButton.click($.proxy(function() {
            $.ajax({
                type: "post",
                url: "/simulation/" + this.simulationId + "/json/points/count",
                success : function(data) {
                    if ((data.count < this.settings.bigLaunchSpots && data.estimatedTime < this.settings.bigLaunchTime) ||
                            confirm('You have ' + data.count + ' points to be computed, the estimated time for this operation is ' + data.estimatedDuration + '. Launch it anyway ?')) {
                        this.launchCoverage();
                    }
                },
                context: this
            });
        }, this));

        var measureTool = new MeasureTool(this.map, {
          contextMenu: false
        });
        
        var menu = new ContextMenu({map: this.map});
        if(this.settings.canEditSimulation && !this.settings.isRestrictedSimu) {
            if (!this.settings.clone) {
                menu.addItem('New station', 0, $.proxy(function(map, latlng){
                    this.addStation(latlng.lat(), latlng.lng());
                }, this));
            }
            menu.addItem('New device', 1, $.proxy(function(map, latlng){
                this.addDevice(latlng.lat(), latlng.lng());
            }, this));
        }
        menu.addItem('Measure start', 2, $.proxy(function(map, latlng){
            measureTool.start([{lat: latlng.lat(), lng: latlng.lng()}]);
            $("#measureClear").show();
            $("#measureStart").hide();
        }, this));

        menu.addItem('Measure clear', 3, $.proxy(function(map, latlng){
            measureTool.end();
            $("#measureClear").hide();
            $("#measureStart").show();
        }, this));

        $("#measureClear").hide();
    
        var colorBlue = '#86adf1';
    
        this.drawingDevice = new google.maps.drawing.DrawingManager({
            map: this.map,
            drawingMode: null,
            drawingControl: false,
            rectangleOptions: {
                fillColor: colorBlue,
                fillOpacity: 0.15,
                strokeColor: colorBlue,
                strokeWeight: 1,
                clickable: false
            }
        });
        google.maps.event.addListener(this.drawingDevice, 'rectanglecomplete', $.proxy(this._onRectangleComplete, this));
        this.devices = {};
        this.lastRectangle = null;
        this.draw = false;
        
        //spot type selector
        if (this.settings.spotTypeSelector) {
            var spotTypeSelector = $(this.settings.spotTypeSelector);
            spotTypeSelector.change($.proxy(function() {
                this.filterBySpotType(spotTypeSelector.val());
            }, this));
        }
    };
    
    //Inherit from MessageMonitoring
    for (var element in BaseStationCoverageMap.prototype) {
        SimulationCoverageMap.prototype[element] = BaseStationCoverageMap.prototype[element];
    }
    
    SimulationCoverageMap.prototype.launchCoverage = function() {
        if (this.launchCoverageButton.isEnabled()) {
            //Disable the submit button to avoid multiple launches
            this.launchCoverageButton.running();
            //launch the simulation coverage
            $.ajax({
                type: "post",
                url: "/simulation/" + this.simulationId + "/run",
                success : function() {
                    // Poll for the simulation status, and enable the button when it is over
                    this.refreshLaunchButton();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(errorThrown == "Not Acceptable") {
                        messages.error('A coverage is currently processing, please wait');
                    } else {
                        messages.error(errorThrown + ' : ' + textStatus);
                    }
                    // Poll for the simulation status, and enable the button when it is over
                    this.refreshLaunchButton();
                },
                context: this
            });
        }
        return false;
    };

    SimulationCoverageMap.prototype.refreshLaunchButton = function(refreshParam) {
        var count = 10;
        periodicChecker.call(this, "/simulation/" + this.simulationId + "/json/status", {
            period: 3000,
            onOk: function(status) {
                this.refreshAll(refreshParam);
                this.launchCoverageButton.updateState(status);
                this.settings.onSuccessProcess(status);
            },
            isComplete: $.proxy(function(status) {
                if (count % 10 == 0) {
                    this.settings.onSuccessProcess(status);
                }
                count++;
                return !status.running;
            }, this)
        });
    };

    SimulationCoverageMap.prototype.filterBySpotType = function(comStateString) {
        for ( var id in this.markers) {
            var marker = this.markers[id];
            var isVisible = comStateString == "all" || 
            	(comStateString == "stations" && marker.markerInfo.type == "station") ||
            	(comStateString == "coveragespots" && marker.markerInfo.type == "coveragespot") ||
            	(comStateString == "staticspots" && marker.markerInfo.type == "static") ||
            	(comStateString == "onlycandidates" && marker.markerInfo.candidate) ||
            	(comStateString == "displaycoverageoff" && marker.markerInfo.coverageDisplayed === false);

            this.updateMarkerVisibility(marker, isVisible);
        }
        this.redrawMarkers();
    };

    SimulationCoverageMap.prototype.onToggleClusterClick = function(){
        BaseStationCoverageMap.prototype.onToggleClusterClick.call(this);
        if (this.settings.spotTypeSelector) {
            var spotTypeSelector = $(this.settings.spotTypeSelector);
            this.filterBySpotType(spotTypeSelector.val());
        }
    };

    /**
     * p: {
     *     update: true|false,
     *     onLoaded: function() {}
     * }
     */
    SimulationCoverageMap.prototype.refreshAll = function(p) {
        var params = {
            update: true,
            onLoaded: function() {}
        };
        $.extend(params, p);
    
        $.ajax({
            type: 'GET',
            url: this.settings.ajaxUrl,
            dataType: "json",
            traditional : true,
            success: function(result) {

                this.settings.useTile = result.useTile === true;
                if (result.useTile) {
                    this.removeTiles()
                    if(result.conf) {
                        this.settings.colorSteps = result.conf.colorSteps;
                        this.settings.targets = result.conf.targets;
                        if (result.geodataBaseImgUrls) {
                            this.settings.densityBaseImgUrl = result.geodataBaseImgUrls[result.conf.currentPopulationSet];
                            this.settings.landCoverBaseImgUrl = result.geodataBaseImgUrls[result.conf.currentLandcoverSet];
                        }
                        this.updateBaseImgUrl([result.baseImgUrl]);
                    }
                } else {
                    // Update coverages
                    this._updateCoverages(result.coverage);
                }
                // Update markers
                if (this.settings.displayMarkers) {
                    this._updateMarkers(result.spots, params.update);
                }
                if(typeof params.onLoaded == "function") {
                    params.onLoaded.call(window, result.spots);
                }
                // load coverage when marker is ready
                $(this.settings.captionSelector).change();
                this.settings.afterLoadCoverage(result);
                
                if (this.settings.refreshGeodata) {
                    var mapTypeId = this.map.getMapTypeId();
                    if (mapTypeId == this.POPULATION_DENSITY) {
                        this.switchMapId("density");
                    } else if (mapTypeId == this.LAND_COVER) {
                        this.switchMapId("landCover");
                    }
                }
            },
            context: this
        });
    };
    
    SimulationCoverageMap.prototype._updateCoverages = function(units) {
        this.removeCoverages();
        for(var i = 0; i < units.length; i++) {
            var unit = units[i];
            unit.bounds = {sw: {lat: unit.latLng.lat,
                                lng: unit.latLng.lng},
                           ne: {lat: unit.latLng.lat + 1,
                                lng: unit.latLng.lng + 1}};
            unit.baseImgUrl = this.settings.binUrl + "/" + unit.id ;
        }
        this.loadCoverages(units);
    };
    
    /**
     * @param spots: the spots to redraw
     * @param update: true if we want to apply a filter, else false 
     */
    SimulationCoverageMap.prototype._updateMarkers = function(spots, update) {
        this.boundsCount = 0;
        var s = spots;
        if(update) {
            s = $.grep(spots, $.proxy(function(spot, index) {
                // The marker does not exist, add it
                var m = this.markers[spot.id];
                if(!m) {
                    return true;
                }
                // Add the marker if its position changed
                var markerInfo = m.markerInfo;
                return markerInfo.lat != spot.lat || markerInfo.lng != spot.lng || markerInfo.coverageDisplayed != spot.coverageDisplayed || markerInfo.coverageDisplayedUpdated;
            }, this));
        } else {
            // Reset bounds
            this.bounds = null;
            // No filter, remove all markers
            this.removeMarkers();
        }
        
        $.each(s, $.proxy(function(index, spot) {
            if(update) {
                // Only remove specific markers when a filter is applied
                this.removeMarker(spot.id);
            }
            var markerInfo = {
                draggable: spot.editable,
                id: spot.baseStationId
            };
            $.extend(markerInfo, spot);
            this.addMarker(markerInfo, !update);
        }, this));
        
    };
    SimulationCoverageMap.prototype.startBounce = function(marker) {
        marker.setAnimation( google.maps.Animation.BOUNCE );
    };
    
    SimulationCoverageMap.prototype.stopBounce = function(marker) {
        marker.setAnimation( null );
    };
    /**
     * @OVERRIDE
     */
    SimulationCoverageMap.prototype._onMarkerClick = function(marker) {
        // Call the super method
        BaseStationCoverageMap.prototype._onMarkerClick.call(this, marker);
        
        //----------------------------- Attach events -------------------------------
        // Reset spot coverage 
        this.infoContent.find("a.coverageReset").click($.proxy(function(markerInfo, event) {
            event.stopPropagation();
            
            // ok user, you got one last chance to step back !
            if(!confirm('Are you sure you want to reset this spot coverage ?')){
                return false;
            }
            
            
            $.ajax({
                method: 'POST',
                url: $(event.currentTarget).data('url'),
                success: function(data) {
                    this.info.close();
                    this.settings.onResetCoverage(markerInfo,data);
                    this.disable();
                    this.refreshLaunchButton();
                },
                context: this
            });
            return false;
        }, this, marker.markerInfo));
        
        // Delete spot
        this.infoContent.find("a.removeSpot").click($.proxy(function(markerInfo, event) {
            event.stopPropagation();
            
            // ok User...you got one last chance to step back !
            if(!confirm('Are you sure you want to remove this spot ?')){
                return false;
            }
            $.ajax({
                method: 'POST',
                url: $(event.currentTarget).data("url"),
                success: function(data) {
                    this.info.close();
                    this.settings.onRemoveSpot(markerInfo);
                    this.removeMarker(markerInfo.id);
                    if(markerInfo.type != "static") {
                        this.refreshLaunchButton();
                    }
                },
                context: this
            });
            return false;
        }, this, marker.markerInfo));

        this.infoContent.find("input.coverageDisplayed").click($.proxy(function(event) {
            this.launchCoverageButton.running();
            marker.markerInfo.coverageDisplayed = $(event.currentTarget).is(':checked');
            marker.markerInfo.coverageDisplayedUpdated = true;
            $.ajax({
                type: 'POST',
                url: this.spotUrl + "/" + event.currentTarget.id + '/displaycoverage',
                data: {coverageDisplayed : marker.markerInfo.coverageDisplayed},
                success: function(data) {
                    this.refreshLaunchButton();
                },
                context: this
            });
        }, this));
        this.infoContent.find(".createSite").click(function(event) {
            $.ajax({
                method: 'POST',
                url: $(event.currentTarget).data('url')
            }).done($.proxy(function(data, textStatus, jqXHR) {
                marker.markerInfo.transformable = false;
                $(this).remove();
                messages.info("The site was successfully created.");
                return false;
            }, this)).fail(function(jqXHR, textStatus, errorThrown) {
                messages.error("The site was not created : " + errorThrown);
                return false;
            });
            return false;
        });
    };
    
    /**
     * @OVERRIDE
     */
    SimulationCoverageMap.prototype._getInfoContent = function(markerInfo) {
        /**
         * Return a row with a label and a value
         */
        var row = function(label, value, unit) {
            if (typeof value != "undefined") {
                return "<div class='row'><span class='label'>" + label + ":</span><span> " + value + (typeof unit != 'undefined' ? ' ' + unit : '') + "</span></div>";
            } else {
                return "";
            }
        };
        /**
         * Display the SNR
         */
        var snr = function(snrInfos) {
            if (typeof snrInfos != "undefined") {
                return '<div class="row"><span class="label">Stations :</span><ul class="snrInfos">' + 
                $.map(snrInfos, function(info) {
                    return "<li>Station: #" + info.hexId + " - Snr: " + info.snr.toFixed(1) + " dB</li>";
                }).join('') +
                '</ul></div>';
            } else {
                return "";
            }
        };
        
        /**
         * Display the External id
         */
        var externalId = function(markerInfo) {
            if (markerInfo.candidate) {
                return '<div class="row"><span class="label">External id :</span><span>' + markerInfo.externalId + '</span></div>';
            } else {
                return "";
            }
        };
        /**
         * Display the toolbar containing the edit and remove actions
         */
        var infotoolbar = function(markerInfo) {
            var result = "";
            if (markerInfo.draggable || markerInfo.removable) {
                result += '<div class="toolbar infotoolbar">';
                var url = (markerInfo.type == "static" ? this.staticUrl : this.spotUrl);
                if (markerInfo.draggable) {
                    result += "<a class='toolbar-button icon' href='" + url + "/" + markerInfo.id + "/edit'><img title ='Edit' src='/resources/img/edit-spot.png?v=" + appData.version + "'/></a>";
                }
                if (markerInfo.removable && !this.settings.isRestrictedSimu) {
                    result += "<a class='toolbar-button icon removeSpot' href='#' data-url='" + url + "/" + markerInfo.id + "/delete'><img title='Remove' src='/resources/img/remove-spot.png?v=" + appData.version + "'/></a>";
                }
                if (markerInfo.coverageResetable && !this.settings.isRestrictedSimu) {
                    result += "<a class='toolbar-button icon coverageReset' href='#' data-url='" + url + "/" + markerInfo.id + "/reset'><img title='Reset coverage' src='/resources/img/reset-spot-coverage.png?v=" + appData.version + "'/></a>";
                }
                if (markerInfo.transformable) {
                    result += "<a class='toolbar-button text createSite' href='#' data-url='/spot/"+ markerInfo.id  + "/coveragespot/createsite'><span>Create site</span></a>";
                }
                result += '</div>';
            }
            return result;
        };

        /**
         * Display a checkbox to select whether we display the coverage for this spot
         */
        var coverageCheckbox = function(markerInfo) {
            var result = "";
            if(markerInfo.type === "station" || markerInfo.type === "coveragespot") {
                result += "<div class='row'><input type='checkbox' class='coverageDisplayed' id='" + markerInfo.id + "' ";
                if (markerInfo.coverageDisplayed === true) {
                    result += "checked='checked'";
                }
                result += "/><label for='coverageDisplayed'>Display coverage</label></div>";
            }
            return result;
        };
        /**
         * Display the title
         */
        var title = function(title) {
            if (typeof title != "undefined") {
                return '<h1>' + title + '</h1>';
            } else {
                return '';
            }
        };
        
        switch(markerInfo.type) {
            case "device":
                return '<p><a href="/device/' + markerInfo.id + '">Device id: ' + markerInfo.hexId + '</a></p>'
                    + '<p>Name: ' + markerInfo.name + '</p>'
                    + '<p>Last message: ' + markerInfo.lastCom + '</p>'
                    + '<p>Link Quality Indicator: <img class="signal-power-img link-quality-info" style="margin: -15px 5px -5px 10px;" title="' + markerInfo.linkQuality + '" src="/resources/img/signal/' + markerInfo.signalStrength + '.png?v=' + appData.version + '"/></p>'
                    + '<p>RSSI: ' + markerInfo.lastRssi + '</p>'
                    + '<p>Lat: ' + markerInfo.lat + '</p>'
                    + '<p>Lng: ' + markerInfo.lng + '</p>';
            default: 
                return title(markerInfo.name) +
                row("Device id", markerInfo.hexDid) +
                row("Time", markerInfo.time) +
                row("Lat", markerInfo.lat) +
                row("Lng", markerInfo.lng) +
                row("Power", markerInfo.power, 'dBm') +
                row("Uplink center frequency", markerInfo.baseFreq, 'Hz') +
                row("Antenna height AGL", markerInfo.elevation, 'm') +
                snr(markerInfo.snrInfos) +
                row("SNR", markerInfo.snr, 'dB') +
                externalId(markerInfo) +
                (this.settings.canEditSimulation && !this.settings.clone && !this.settings.readOnlyMode ? coverageCheckbox(markerInfo) : "") +
                infotoolbar.call(this, markerInfo);
        }
    };
    
    /**
     * @OVERRIDE
     */
    SimulationCoverageMap.prototype._onMarkerDragEnd = function(event, markerInfo) {
        var data = {
            lat : event.latLng.lat(),
            lng : event.latLng.lng(),
            notReceived : markerInfo.notReceived
        };
        var url = (markerInfo.type == "static" ? this.staticUrl : this.spotUrl);
        if(markerInfo.type != "static") {
            this.launchCoverageButton.running();
        }
        // A marker has moved
        // Refresh coverage
        $.ajax({
            type: 'POST',
            url: url + "/" + markerInfo.id,
            data : data,
            traditional : true,
            success : function() {
                if(markerInfo.type != "static") {
                    this.refreshLaunchButton();
                }
            },
            context: this
        });
    };
    
    SimulationCoverageMap.prototype.addStation = function(lat, lng) {
        this.launchCoverageButton.updated();
        // Save the new spot 
        $.ajax({
            type: 'POST',
            url: this.spotUrl,
            dataType: "json",
            data: {lat : lat, lng : lng},
            traditional: true,
            success: function(result) {
                // Add the new spot on the map
                var markerInfo = {
                    title : "Station",
                    draggable: result.editable
                };
                $.extend(markerInfo, result);
                this.addMarker(markerInfo, false);
            },
            context: this
        });
    };
    
    SimulationCoverageMap.prototype.addDevice = function(lat, lng) {
        // Save the new device 
        $.ajax({
            type: 'POST',
            url: this.staticUrl,
            dataType: "json",
            data : {lat : lat, lng : lng},
            traditional : true,
            success: function(result) {
                // Add the new device on the map
                var markerInfo = {
                    title : "Device",
                    draggable: result.editable
                };
                $.extend(markerInfo, result);
                this.addMarker(markerInfo, false);
            },
            context: this
        });
    };
    
    /**
     * @OVERRIDE
     */
    SimulationCoverageMap.prototype._getIcon = function(markerInfo) {

        // Additional type info for the suffix in array
        var locationSuffix = markerInfo.location == 0 ? '-outdoor' : '-indoor';
        var iconPrefix = markerInfo.iconPrefix;
        
        switch(markerInfo.type) {
            case "static":
                return markerInfo.notReceived ? icon.message.NOT_RECEIVED : icon.device["POWER_" + markerInfo.power];
                break;
            case "coveragespot":
                var color = markerInfo.coverageDisplayed ? "-blue" : "-gray";
                return icon.mkIcon(iconPrefix + locationSuffix + color);
                break;
            case "station":
                var color;
                if (markerInfo.coverageDisplayed){
                    color = "-purple";
                }else{
                    color = "-gray";
                }
                return icon.mkIcon(iconPrefix + locationSuffix + color);
                break;
            case "device":
                if (this.settings.deviceMode == "STATUS") {
                  return icon.device[this.settings.deviceMode + "_" + markerInfo.comStateString.toUpperCase()];
                }
                break;
        }
        return null;
    };
    
    /**
     * @OVERRIDE
     */
    SimulationCoverageMap.prototype.addMarker = function(markerInfo, fitBounds) {
        return BaseStationCoverageMap.prototype.addMarker.call(this, markerInfo, fitBounds, markerInfo.type !== "coveragespot" && markerInfo.type !== "station");
    };
    
    /**
     * @OVERRIDE
     */
    SimulationCoverageMap.prototype.removeMarker = function(id) {
        BaseStationCoverageMap.prototype.removeMarker.call(this, id);
    };
    
    SimulationCoverageMap.prototype.disable = function() {
        this.launchCoverageButton.running();
    };
    
    SimulationCoverageMap.prototype.enable = function(status) {
        this.launchCoverageButton.updateState(status);
    };
    
    SimulationCoverageMap.prototype.toggleDraw = function() {
        this.draw = !this.draw;
        // Place the marker by dragging it
        if (this.draw) {
            this.drawingDevice.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
        } else {
            // remove devices
            this.removeDevices();
            // remove the rectangle (if any)
            if (this.lastRectangle) {
                this.lastRectangle.setMap(null);
            }
            this.drawingDevice.setDrawingMode(null);
        }
        return this.draw;
    };
    
    SimulationCoverageMap.prototype._onRectangleComplete = function(rectangle) {
        var data = {
                neLat : rectangle.getBounds().getNorthEast().lat(),
                neLng : rectangle.getBounds().getNorthEast().lng(),
                swLat : rectangle.getBounds().getSouthWest().lat(),
                swLng : rectangle.getBounds().getSouthWest().lng()
            };
        if (this.lastRectangle) {
            this.lastRectangle.setMap(null);
        }
        this.lastRectangle = rectangle;
        // A rectangle is 
        // Refresh coverage
        $.ajax({
            type: 'POST',
            url: '/simulation/' + this.simulationId + '/json/devices',
            data: data,
            success: function(data) {
                if(data.spots) {
                    // clear all anciant markers
                    this.removeDevices();
                    // Add devices markers to the map
                    $.each(data.spots, function(index, value) {
                        $.extend(value, {
                            type: 'device',
                            draggable: false
                        });
                    });
                    for(var i = 0; i < data.spots.length; i++) {
                        this.devices[data.spots[i].id] = this.addMarker(data.spots[i], false);
                    }
                    this.settings.onDevicesAdded();
                }
                if(data.feedback) {
                    messages.warn(data.feedback);
                }
            },
            context: this
        });
    };

    // fullscreen toggle actions
    SimulationCoverageMap.prototype._fullscreenToggle = function(activate) {
        if (activate) {
            var wrapperId = "#"+this.settings.fullScreen;
            $("#feedback").appendTo(wrapperId);
            $(".list-selector-dialog").appendTo(wrapperId);
            $(".csv-export-dialog").appendTo(wrapperId);
            $("#ui-datepicker-div").appendTo(wrapperId);
        } else {
            $("#feedback").appendTo("body");
            $(".list-selector-dialog").appendTo("body");
            $(".csv-export-dialog").appendTo("body");
            $("#ui-datepicker-div").appendTo("body");
        }
    };

    /*
     * Manage City area display
     */
    SimulationCoverageMap.prototype.makeToggleCityArea = function(){
        var controlUI = $('<div></div>').addClass("gmnoprint city-area");
        var divUI = $('<div></div>', {
            'class': 'control-ui'
        }).appendTo(controlUI);
        this.cityAreaControlText = $('<div></div>', {'title': 'Toggle city area display'}).addClass("control-text").appendTo(divUI);
        if (this.settings.cityArea.list) {
            this.cityAreaText(true);
            this.options = $("<select></select>").addClass("control-text city-area-options").appendTo(divUI);
            for (var cityarea in this.settings.cityArea.list) {
                this.options.append($("<option />").val(this.settings.cityArea.list[cityarea].id).text(this.settings.cityArea.list[cityarea].name));
            }
            this.options.selectmenu({
                appendTo: "#map-wrapper",
                change: $.proxy(this.onChangeCityArea, this),
            }).selectmenu( "menuWidget" ).addClass( "city-area-list" );
            divUI.find("span.ui-selectmenu-button").addClass("control-text");
            this.options.selectmenu( "disable" );
            google.maps.event.addDomListener(controlUI.get()[0], 'click', $.proxy(this.onToggleCityAreaClick, this));
        } else {
            this.cityAreaText(false);
        }
        this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(controlUI.get()[0]);
        this.buildCityAreaSlider();
    };
    
    SimulationCoverageMap.prototype.onToggleCityAreaClick = function(event){
        if ($(event.target).is(this.cityAreaControlText)) {
            var cityAreaId = this.options.val();
            this.enableCityArea(!this.settings.cityArea.isDisabled, cityAreaId);
        }
    };
    
    SimulationCoverageMap.prototype.onChangeCityArea = function(event){
        var cityAreaId = this.options.val();
        this.enableCityArea(this.settings.cityArea.isDisabled, cityAreaId);
    };

    SimulationCoverageMap.prototype.cityAreaText = function(active) {
        if (active) {
            this.cityAreaControlText.html(this.settings.cityArea.isDisabled ? 'City area display : Off' : 'City area display : On');
        } else {
            this.cityAreaControlText.html('City area display : N/A');
        }
    };

    SimulationCoverageMap.prototype.enableCityArea = function(disabled, cityAreaId){
        if (!disabled) {
            this.options.selectmenu( "enable" );
            this.cityAreaSliderDiv.show();
            $.ajax({
                type: 'GET',
                url: '/cityArea/' + cityAreaId + '/json/get',
                success: function(data) {
                    this.cityArea.load(data, (this.settings.cityArea.opacity / 100));
                },
                context: this
            });
        } else {
            this.options.selectmenu( "disable" );
            this.cityArea.clean();
            this.cityAreaSliderDiv.hide();
        }
        this.settings.cityArea.isDisabled = disabled;
        this.cityAreaText(true);
    };
    

    SimulationCoverageMap.prototype.buildCityAreaSlider = function() {
        // Opacity slider
        this.cityAreaSliderDiv = $("<div title='City area opacity' id='city-area-slider'></div>");
        var slider = this.cityAreaSliderDiv.slider({
            value: this.settings.cityArea.opacity
        });
        slider.bind("slide", {_this: this}, $.proxy(function(event, ui) {
            event.data._this.settings.cityArea.opacity = ui.value;
            this.cityArea.updateOpacity((ui.value / 100));
        }, this));
        this.cityAreaSliderDiv.hide();
        this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(this.cityAreaSliderDiv.get(0));
    }

    /**
     * <pre>
     * Remove devices markers
     * If the filter function returns true, the marker is deleted, else it is kept
     * If the filter function is not defined, all markers are deleted
     * </pre>
     */
    SimulationCoverageMap.prototype.removeDevices = function() {
        for(var id in this.devices) {
            if(this.devices.hasOwnProperty(id)) {
                this.removeMarker(id);
            }
        }
    };

    return SimulationCoverageMap;
});


